import {
  makeStyles,
  useTheme,
  useMediaQuery,
  Tabs,
  Tab,
  Paper,
  Box,
  CircularProgress,
  Typography
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { PAGE_SIZE_LIST, STATUS_API } from 'src/app/constant/config';
import { useQuery } from 'src/app/hooks/useQuery.js';
import { _convertObjectToQuery } from 'src/app/utils/apiService.js';
import {
  getListServicePackages
} from 'src/features/servicePackageSlice.js';
import { getListAgencies } from 'src/features/agencySlice.js';
import Results from './Results.js';
import ToolBar from './ToolBar.js';
import ConfigServicePackagePanel from '../agency/ConfigServicePackagePanel.js';

const ServicePackageView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
  const query = useQuery();
  const classes = useStyles();
  
  const [params, setParams] = useState({
    page: 1,
    page_size: isMobile ? 6 : PAGE_SIZE_LIST
  });

  const [tabIndex, setTabIndex] = useState(0);

  const statusCreate = useSelector(
    state => state.servicePackageSlice.statusCreate
  );
  const statusDelete = useSelector(
    state => state.servicePackageSlice.statusDelete
  );
  const statusMultiDelete = useSelector(
    state => state.servicePackageSlice.statusMultiDelete
  );
  const statusUpdate = useSelector(
    state => state.servicePackageSlice.statusUpdate
  );
  const listServicePackages = useSelector(
    state => state.servicePackageSlice.listServicePackages
  );
  const isAdmin = useSelector(
    state => state.authSlice.isAdmin
  );
  const listAgencies = useSelector(
    state => state.agencySlice.listAgencies
  );
  const loadingAgencies = useSelector(
    state => state.agencySlice.isLoading
  );

  const page = query.get('page') || 1;
  const keywords = query.get('keywords');

  useEffect(() => {
    const queryValue = {
      ...params,
      page: page ? page : undefined,
      keywords: keywords ? keywords : undefined
    };
    setParams(queryValue);
  }, [query]);

  useEffect(() => {
    dispatch(getListServicePackages(params));
  }, []);

  useEffect(() => {
    if (isAdmin) {
      dispatch(getListAgencies({ page_size: 1000 }));
    }
  }, [isAdmin]);

  useEffect(() => {
    if (listAgencies) {
      console.log('Danh sách đại lý tải được:', listAgencies);
    }
  }, [listAgencies]);

  const getListServicePackagesWithParams = query => {
    navigate('/app/manage/service-packages?' + _convertObjectToQuery(query));
    dispatch(getListServicePackages(query));
  };

  useEffect(() => {
    if (
      statusCreate === STATUS_API.SUCCESS ||
      statusDelete === STATUS_API.SUCCESS ||
      statusMultiDelete === STATUS_API.SUCCESS ||
      statusUpdate === STATUS_API.SUCCESS
    ) {
      getListServicePackagesWithParams(params);
    }
  }, [statusCreate, statusDelete, statusUpdate, statusMultiDelete]);

  const vamkeAgency = (listAgencies || []).find(
    a =>
      a?.name?.toLowerCase().includes('vmake') ||
      a?.agency_code?.toLowerCase().includes('vmake') ||
      a?.leader?.username?.toLowerCase().includes('vmake') ||
      a?.name?.toLowerCase().includes('vamke') ||
      a?.agency_code?.toLowerCase().includes('vamke') ||
      a?.leader?.username?.toLowerCase().includes('vamke')
  );

  return (
    <>
      <div className={classes.root}>
        <div style={{ width: '98%', margin: '0 auto' }}>
          {isAdmin ? (
            <>
              <Tabs
                value={tabIndex}
                onChange={(e, val) => setTabIndex(val)}
                indicatorColor="primary"
                textColor="primary"
                style={{ marginBottom: '16px', borderBottom: '1px solid #e0e0e0' }}
              >
                <Tab label="Gói cước Đại lý" style={{ textTransform: 'none', fontWeight: 600 }} />
                <Tab label="Gói cước Khách lẻ" style={{ textTransform: 'none', fontWeight: 600 }} />
              </Tabs>

              {tabIndex === 0 && (
                <>
                  <ToolBar searchRef={getListServicePackagesWithParams} hideTitle={isAdmin} />
                  <Results
                    className="mt-3"
                    listServicePackages={listServicePackages}
                    getListServicePackagesWithParams={getListServicePackagesWithParams}
                  />
                </>
              )}

              {tabIndex === 1 && (
                <>
                  {loadingAgencies ? (
                    <Paper style={{ padding: '24px', marginTop: '16px' }}>
                      <Box display="flex" justifyContent="center" py={4}>
                        <CircularProgress size={30} style={{ color: '#D9042F' }} />
                      </Box>
                    </Paper>
                  ) : vamkeAgency ? (
                    <ConfigServicePackagePanel agencySelected={vamkeAgency} hideTitle={true} isRetail={true} />
                  ) : (
                    <Paper style={{ padding: '24px', marginTop: '16px' }}>
                      <Box py={3} textAlign="center">
                        <Typography color="error">
                          Không tìm thấy đại lý "vamke" trong hệ thống để cấu hình gói cước khách lẻ.
                        </Typography>
                      </Box>
                    </Paper>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              <ToolBar searchRef={getListServicePackagesWithParams} />
              <Results
                className="mt-3"
                listServicePackages={listServicePackages}
                getListServicePackagesWithParams={getListServicePackagesWithParams}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    width: '100%',
    paddingTop: theme.spacing(2)
  },
}));

export default ServicePackageView;
